import { BeatblipUtils } from './../../consts/beatblip-utils';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ComponentFactory, ComponentFactoryResolver, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartColor, ChartOptions, ChartType, ChartDataSets, ChartData } from 'chart.js';
import { Label } from 'ng2-charts';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ExcelService } from 'src/app/_services/excel.service';
import { ProjectService } from 'src/app/_services/project.service';
import { ReportService } from 'src/app/_services/report.service';
import { TestService } from 'src/app/_services/test.service';
import { Chart } from '../latest-report/chart';
import { Location } from '@angular/common';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { HomeService } from 'src/app/_services/home.service';
import { UserService } from 'src/app/_services/user.service';
// import { ChartOptions, ChartType,ChartDataSets } from 'chart.js';

@Component({
  selector: 'app-test-run-detail',
  templateUrl: './test-run-detail.component.html',
  styleUrls: ['./test-run-detail.component.scss']
})
export class TestRunDetailComponent implements OnInit {
  dataIterationIndex: any;
  projectId: any;
  projectReportData: any;
  projectData: Object;
  projectName: any;
  reportId: string;
  testDataId: string;
  path: string;
  title: string;
  status: string;
  reportForNavBar: string;
  iteration= 0;
  testSuiteReportData: Object;
  testCaseReportData: any;
  emailIdforReport={list:[]}
  haveEmailIDs: boolean = true;
 enableAuditInfo: boolean =false;
  enableScreenPath: boolean = false;
  public chartOptionSelect = ['pie','bar'];
  copyMessage: any;
  public barChartColors: ChartColor[] = [
    'rgb(92, 184, 92)',
    'rgb(217, 83, 79)',
    'rgb(236, 59, 15)',
    'rgb(240, 173, 78)',
     'rgb(91, 192, 222)', 
     'rgb(102, 205, 170)'
  ]
  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom',
    }
  };
  charData: any=[];
  public newChartData: ChartData[]=[];
  public barChartLabels: Label[];
  public barChartType: ChartType = 'pie';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[]=[];
  public pieColor: ChartColor[]=[];

  chartList: Array<Chart> = [];
  blinkArry: any[]=[];
  numarray: Array<Number>=[];
  testLabels: any[] = [];
  suiteIndex=0;
  totalSteps: any;
  passCount: number;
  failCount: number;
  blockedCount: number;
  incolusiveCount: number;
  notRunCount: number;
  skippedCount: number;
  componentFactory: ComponentFactory<any>;
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any = 1;
  testStepStats: any;
  testStepReport: any;
  runNewReport: any='false';
  totalPages: any;

  nextLink: boolean;
  preLink : boolean;
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Latest Execution Report',
    data: undefined,
  }
  index1: number=0;


  constructor(
    private report: ReportService,
    private project: ProjectService,
    private testService:TestService,
    private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private route: ActivatedRoute,
  private toastrService:ToastrService,
  private confirmationDialogService:ConfirmationDialogService,
  private excelService:ExcelService,
  private utils: BeatblipUtils,
  private location: Location,
  private router: Router,
  private homeService: HomeService,
  private componentFactoryResolver: ComponentFactoryResolver,
  private userService: UserService,
  
  @Inject( DOCUMENT ) private document: Document,
  ) { }
  @ViewChild('cancelEmailModal') cancelEmailModal: ElementRef;
  @ViewChild('addEmail') addEmail: ElementRef;
  ngOnInit() {
    this.route.paramMap.subscribe(
      params => {
        //:pid/:reportId/:testDataId/:path/:title/:iteration/:status
        this.projectId = params.get('pid');
        this.reportId = params.get('reportId');
        this.testDataId = params.get('testDataId');
        this.path = params.get('path');
        this.title =params.get('title');
        this.status = params.get('status');
        this.dataIterationIndex = params.get('iteration');
        //console.log('path',this.path);
        
        // this.dataIteraion
        if(this.status.includes('latest')){
          this.reportForNavBar = 'Latest Execution Report'
        }else{
          this.reportForNavBar = 'Historical Report'
        }
        //console.log(this.status);
        //console.log(this.reportForNavBar);
       this.project.getProjectById(this.projectId).subscribe(
         (data)=>{
           this.projectData = data;
           this.headerOptions.data = {
             projectId: this.projectId,
             projectName: data['projectName']
           };
           //set header details
           this.homeService.setHeaderOptions(this.headerOptions);

          //  this.testService.getTestCaseTestReport(this.projectId,this.reportId,this.testDataId,this.path,0).subscribe(
          //   (data)=>{
          //     this.testCaseReportData = data;
          //     //console.log('testCaseReportData',this.testCaseReportData);
          //   }
          // )
          this.getTestSuiteTestReport(this.projectId,this.reportId,this.testDataId,this.path,this.dataIterationIndex);
          
          //  this.projectName = this.projectData.projectName
         }
       )
       
      }
    )
    
}


getTestTestTestReport(projectid,reportId,testDataId,path,title){
  this.testService.getTestSuiteTestReport(projectid,reportId,testDataId,path,title,this.dataIterationIndex).subscribe(
    data=>{
      this.testStepStats=data['testCaseSummaryReport'];
      let index = this.testStepStats.findIndex(x => x.title === this.title);
      //console.log('inxed',index,': length of object',this.testStepStats.length-1);
      
      if(this.testStepStats.length == 1)
      { 
        this.preLink = false;
        this.nextLink = false;
      }
      else if(index===this.testStepStats.length - 1){
        this.nextLink = false;
        this.preLink = true;
      }else if(index ===0){
        this.preLink = false;
        this.nextLink = true;
      }
      else{
        this.preLink = true;
        this.nextLink = true;
      }
      //console.log('this.testStepStats', this.testStepStats);
    }
  )
}

getNext(){
//console.log(this.testStepStats);
this.testCaseReportData = []
let index = this.testStepStats.findIndex(x => x.title === this.title);
if(index===this.testStepStats.length-1){
  this.nextLink = false;
  this.preLink = true;
}else{
  this.nextLink = true;
  this.preLink = true;
}
//console.log('index',index);
for (var i = index; i < this.testStepStats.length; i++) {
  var next = this.testStepStats[i+1];
  //console.log('next',next);
  this.router.navigate(['testStepReport/'+this.projectId+'/'+this.reportId+'/'+next.testDataId+'/'+next.path+'/'+next.title+'/'+next.dataIterationIndex+'/'+this.status])
  setTimeout(() => {
    this.document.defaultView.location.reload();
  }, 0);
  break;
}

}

getPrevious(){
  this.testCaseReportData = []
  //console.log(this.testStepStats);
  let index = this.testStepStats.findIndex(x => x.title === this.title);
  if(index===this.testStepStats.length-1){
    this.nextLink = true;
    this.preLink = false;
  }else{
    this.nextLink = true;
    this.preLink = true;
  }
  //console.log('index',index);
  for (var i = index; i < this.testStepStats.length; i++) {
      var previous = this.testStepStats[i-1] ;
      //console.log('previous',previous);

      this.router.navigate(['testStepReport/'+this.projectId+'/'+this.reportId+'/'+previous.testDataId+'/'+previous.path+'/'+previous.title+'/'+previous.dataIterationIndex+'/'+this.status])
     
      setTimeout(() => {
        
        this.document.defaultView.location.reload();
      }, 0);
      break;
  }

  }

  goToTestCaseSummay(){
    //console.log('step report for redirecting',this.testStepReport);
    
  }


toggleWithGreeting(popover, greeting: string, language: string) {
  if (popover.isOpen()) {
    popover.close();
  } else {
    popover.open({greeting, language});
  }
}

onPageChange(newValue) {
  this.selectedPage = newValue;
  this.perpageitem = newValue;
}
copyToClipboard(item): void {
  //console.log(item)
  // let listener = (e: ClipboardEvent) => {
  //     e.clipboardData.setData('text/plain', (item));
  //     e.preventDefault();
  // };

  // document.addEventListener('copy', listener);
  // document.execCommand('copy');
  // document.removeEventListener('copy', listener);
  this.utils.copyToClipboard(item);
  this.toastrService.clear();
  this.toastrService.success('Copy To Clipboard');
}

selectChartType(chartType){
  this.barChartType = chartType;
}
goBack() {
  this.location.back();
}

allFlag:any;

fullData: any[] = [];
pagedData: any[] = [];
currentPage: number = 1;
itemsPerPage: number = 100;
updatePageData(): void {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  this.pagedData = this.fullData.slice(startIndex, endIndex);
}

goToPage(page: number): void {
  if (page >= 1 && page <= this.totalPages) {
   this.currentPage = page;
  this.selectedPage = this.currentPage;
  this.perpageitem = this.itemsPerPage;
  this.getTestSuiteTestReport(this.projectId,this.reportId,this.testDataId,this.path,this.dataIterationIndex);
    // this.updatePageData();
  }
}

nextPage(): void {
  this.goToPage(this.currentPage + 1);
 

}

prevPage(): void {
  this.goToPage(this.currentPage - 1);
  
}


updatePagination() {
  const pages: (number | string)[] = [];
  const total = this.totalPages;
  const current = this.currentPage;

  // Always show first 3
  for (let i = 1; i <= Math.min(3, total); i++) {
    pages.push(i);
  }

  // Add ellipsis if needed
  if (current > 3 && total > 6) {
    pages.push('...');
  }

  // Show current page with neighbors
  const start = Math.max(4, current - 1);
  const end = Math.min(total - 3, current + 1);

  for (let i = start; i <= end; i++) {
    if (!pages.includes(i)) pages.push(i);
  }

  // Add ellipsis if needed
  if (current < total - 4 && total > 6) {
    pages.push('...');
  }

  // Always show last 3
  for (let i = total - 2; i <= total; i++) {
    if (i > 3 && !pages.includes(i)) {
      pages.push(i);
    }
  }

  this.paginationPages = pages;
}
paginationPages: (number | string)[] = [];
getTestSuiteTestReport(projectid,reportId,testDataId,path,dataIteration){
  

  this.userService.getLoginFlag().subscribe(
      (res:any)=>{
          this.allFlag = res['configFlags']
          this.runNewReport = this.allFlag.find((f:any)=>f.name=='runNewReport').value;

          if(this.runNewReport == "true") {

      this.testService.getTestCaseTestReportV2(projectid,reportId,testDataId,path,dataIteration,this.selectedPage,this.perpageitem).subscribe(
      data=>{
        //console.log('dataindex',this.dataIterationIndex);
      
        this.testCaseReportData=data;
        if(this.testCaseReportData['testStepReport']){

          this.fullData = Array.from({ length: 5000 }, (_, i) => ({ id: i + 1, name: `Item ${i + 1}` }));
          this.totalPages = Math.ceil(this.testCaseReportData['totalSteps'] / this.perpageitem);
          this.updatePagination()
          this.updatePageData();
         this.index1 = (this.selectedPage - 1) * this.perpageitem
        // for (let index = this.index1; index < this.index1+ this.perpageitem; index++) {
        //   this.testCaseReportData['testStepReport'][index]['stepIndex'] = index; 
          
        // }
        this.testStepReport = this.testCaseReportData['testStepReport'];
        console.log(this.testStepReport);
      }
      else{
        this.toastrService.clear();
        this.toastrService.warning('Custom setting flag "skip_step_details_in_web_report " is enabled, Can not see detail report to see the report kindly disable the flag')
      }
        var path1 = this.testCaseReportData.path.split(',')
        //console.log('path ',path1);
        //console.log('path slipt',path1[0]);
        //console.log('path slipt1',path1[1]);
        //console.log('path slipt2',path1[2]);
        //console.log('path slipt3',path1[3]);
        
        this.getTestTestTestReport(this.testCaseReportData.projectId,this.testCaseReportData.testProjectReportId,this.testCaseReportData.parentTestDataId,","+path1[1]+",",path1[2]);
        //console.log('testCaseReportData ', this.testCaseReportData);
        //console.log('testCaseReportData ', this.testCaseReportData.aggrResultState);
        var projectSummary = this.testCaseReportData.aggrResultState;
        this.totalSteps = this.testCaseReportData.testStepReport.length;
      this.passCount = 0;
        this.failCount = 0;
        this.blockedCount=0;
        this.incolusiveCount=0;
        this.notRunCount = 0;
        this.skippedCount = 0;
        for(let i=0; i< this.totalSteps; i++){
        if(this.testCaseReportData.testStepReport[i].resultState.status=='PASS'){
          this.passCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='FAIL'){
          this.failCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='BLOCKED'){
          this.blockedCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='INCONCLUSIVE'){
          this.incolusiveCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='NOTRUN'){
          this.notRunCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='SKIPPED'){
          this.skippedCount++
        }
        }
          //console.log(this.passCount);
          
        
          let chartObj = new Chart();
          chartObj.pass = this.passCount;
          chartObj.fail = this.failCount;
          chartObj.blocked = this.blockedCount;
          chartObj.inconclusive = this.incolusiveCount
          chartObj.notRun = this.notRunCount;
          chartObj.skipped = this.skippedCount;
          this.chartList.push(chartObj);
        this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
        for(let c of this.chartList){
          this.blinkArry.push(Object.values(c));
        }
        this.numarray = JSON.parse(JSON.stringify(this.blinkArry[0]));
        const toNumbers = arr => arr.map(Number);
        var n = toNumbers(this.numarray);
        this.barChartData = [{ data:  n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
        this.newChartData = [{datasets: this.barChartData}]
        //console.log('newChartData',this.newChartData);
        
      }
    )

    } else {
      this.testService.getTestCaseTestReport(projectid,reportId,testDataId,path,dataIteration).subscribe(
      data=>{
        //console.log('dataindex',this.dataIterationIndex);
      
        this.testCaseReportData=data;
        if(this.testCaseReportData['testStepReport']){
        for (let index = 0; index < this.testCaseReportData['testStepReport'].length; index++) {
          this.testCaseReportData['testStepReport'][index]['stepIndex'] = index; 
          
        }
        this.testStepReport = this.testCaseReportData['testStepReport'];
        console.log(this.testStepReport);
      }
      else{
        this.toastrService.clear();
        this.toastrService.warning('Custom setting flag "skip_step_details_in_web_report " is enabled, Can not see detail report to see the report kindly disable the flag')
      }
        var path1 = this.testCaseReportData.path.split(',')
        //console.log('path ',path1);
        //console.log('path slipt',path1[0]);
        //console.log('path slipt1',path1[1]);
        //console.log('path slipt2',path1[2]);
        //console.log('path slipt3',path1[3]);
        
        this.getTestTestTestReport(this.testCaseReportData.projectId,this.testCaseReportData.testProjectReportId,this.testCaseReportData.parentTestDataId,","+path1[1]+",",path1[2]);
        //console.log('testCaseReportData ', this.testCaseReportData);
        //console.log('testCaseReportData ', this.testCaseReportData.aggrResultState);
        var projectSummary = this.testCaseReportData.aggrResultState;
        this.totalSteps = this.testCaseReportData.testStepReport.length;
      this.passCount = 0;
        this.failCount = 0;
        this.blockedCount=0;
        this.incolusiveCount=0;
        this.notRunCount = 0;
        this.skippedCount = 0;
        for(let i=0; i< this.totalSteps; i++){
        if(this.testCaseReportData.testStepReport[i].resultState.status=='PASS'){
          this.passCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='FAIL'){
          this.failCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='BLOCKED'){
          this.blockedCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='INCONCLUSIVE'){
          this.incolusiveCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='NOTRUN'){
          this.notRunCount++
        }
        if(this.testCaseReportData.testStepReport[i].resultState.status=='SKIPPED'){
          this.skippedCount++
        }
        }
          //console.log(this.passCount);
          
        
          let chartObj = new Chart();
          chartObj.pass = this.passCount;
          chartObj.fail = this.failCount;
          chartObj.blocked = this.blockedCount;
          chartObj.inconclusive = this.incolusiveCount
          chartObj.notRun = this.notRunCount;
          chartObj.skipped = this.skippedCount;
          this.chartList.push(chartObj);
        this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
        for(let c of this.chartList){
          this.blinkArry.push(Object.values(c));
        }
        this.numarray = JSON.parse(JSON.stringify(this.blinkArry[0]));
        const toNumbers = arr => arr.map(Number);
        var n = toNumbers(this.numarray);
        this.barChartData = [{ data:  n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
        this.newChartData = [{datasets: this.barChartData}]
        //console.log('newChartData',this.newChartData);
        
      }
    )
    }
      }
  );

 
  
}



addEmailIdForReport(addEmailForm){
  if(addEmailForm.value.userEmail.trim().length == 0)
  {
    return;
  }
  this.emailIdforReport.list.push(addEmailForm.value.userEmail)
  this.haveEmailIDs=false;
//console.log(this.emailIdforReport);
addEmailForm.reset();
}

sendEmail(){
 
  this.report.shareReport(this.projectId,this.reportId,this.testDataId,this.iteration,this.emailIdforReport).subscribe(
    (data)=>{
      //console.log(data)
      this.toastrService.clear();
      this.toastrService.success('Email Sent successfully');
      this.cancelEmailModal.nativeElement.click();
    }
  )
}
deleteRow(i){
  // this.emailIdforReport.list.splice(0,i);
  //console.log(this.emailIdforReport);
  this.emailIdforReport.list.forEach((element,index)=>{
    if(index==i) this.emailIdforReport.list.splice(index,1);
 });
}

reportPage(event) {
  //console.log('event',event.target.innerHTML);
  var ti = event.target.innerHTML;
  if(ti==='Historical Report'){
    this.router.navigate(['report/testReport/'+this.projectId+'/historical']);
  }else{
    this.router.navigate(['report/testReport/'+this.projectId+'/latest']);
  }
}

onChecked(isChecked: boolean) {
  if(isChecked) {
    this.enableAuditInfo = true;
  } else{
    this.enableAuditInfo = false;
  }
}

onCheckedPath(isChecked: boolean) {
  if(isChecked) {
    this.enableScreenPath = true;
  } else{
    this.enableScreenPath = false;
  }
}
exportPdf(){
  //Step#							End Time	Duration(seconds)	
  var excelReportData = new Array();
  var counter = 1;
    for (var z = 0; z < this.testCaseReportData.testStepReport.length; z++) {
        var tempObject = new Object();
        tempObject['Step#'] = counter++;
        tempObject['Action'] = this.testCaseReportData.testStepReport[z].action;
        tempObject['Screen'] = this.testCaseReportData.testStepReport[z].pageName;
        tempObject['Element'] = this.testCaseReportData.testStepReport[z].elementKey;
        tempObject['Parameters'] = this.testCaseReportData.testStepReport[z].parameters;
        tempObject['Status'] = this.testCaseReportData.testStepReport[z].resultState.status;
        tempObject['StartTime'] = this.testCaseReportData.testStepReport[z].startTime;
        tempObject['EndTime'] = this.testCaseReportData.testStepReport[z].endTime;
        tempObject['Duration'] = this.testService.getDuration(this.testCaseReportData.testStepReport[z].startTime, this.testCaseReportData.testStepReport[z].endTime);
        tempObject['Audit Info'] =  JSON.stringify(this.testCaseReportData.testStepReport[z].auditInfoS);
        // tempObject['FailureReason'] = this.testService.getFailedReason(reportDataForCheck[k].testCaseSummaryReport[z].failedReason);
        excelReportData.push(tempObject);
    }
  //console.log(excelReportData);
  this.exportAsXLSX(excelReportData)
}

exportAsXLSX(excelReport):void {
  this.excelService.exportAsExcelFile(excelReport, 'Tests Step Report');
}

}
